package signSymptom.components

import antd.button.button
import com.jingfangpai.common.orm.mapping.SignSymptom
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import kotlinext.js.jsObject
import kotlinx.browser.document
import org.w3c.dom.HTMLScriptElement
import react.*
import react.dom.*
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.layout.space
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.modal.modal
import antd.radio.RadioChangeEvent
import antd.radio.radio
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.option
import antd.select.select
import antd.tag.tag
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.SignSymptomRelation
import com.jingfangpai.common.orm.mapping.enums.*
import com.jingfangpai.signSymptom.model.SignSymptomNames
import com.jingfangpai.signSymptom.model.SignSymptomRelationDto
import external.select.filterOptionFun
import kotlinext.js.Object
import react.router.dom.useHistory
import signSymptom.containers.SignSymptomEditPageContext
import urlBase
import user.service.AuthService
import external.select.filterOptionFun

external interface SignSymptomEditProps : RProps {
    var id:String
}

data class SignSymptomEditContextData(var placeHolderFunction: (param: String) -> Unit)

val SignSymptomEdit = functionalComponent<SignSymptomEditProps> { props ->

    val ctx = useContext(SignSymptomEditPageContext)
    val history = useHistory()
    val (signSymptom,setSignSymptom) = useState(SignSymptom().apply{
         type = SignSymptomType.单项
         status = SignSymptomStatus.正常
         createdBy = ""
         createdOn = DateTime()
         timestamp = DateTime()
         weight = 0
    })
    val (editorScriptLoaded, setEditorScriptLoaded) = useState(false)
    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)
    val (signSymptomNames,setSignSymptomNames) = useState(SignSymptomNames())
    var signSymptomOptions by useState(arrayOf<CascadedOption<String>>())
    val (showCharacteristicEditForm,setShowCharacteristicEditForm) = useState(false)
    var showExclusiveSignSymptomcEditForm by useState(false)
    val (editingSignSymptomCharacteristic,setEditingSignSymptomCharacteristic) = useState(SignSymptomCharacteristic())
    var editingExclusiveSignSymptom by useState(SignSymptomRelation())
    var exclusiveSignSymptomIds by useState(listOf<String>())
    var exclusiveSignSymptoms by useState(listOf<SignSymptomRelationDto>())
    val (characteristics,setCharacteristics) = useState(arrayOf<SignSymptomCharacteristic>())

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance:CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor:CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        if(signSymptom.name == null){
            message.error("请选择症状/体征名称");
            return;
        }
        editor?.let {
            editor?.getData()?.let{ data ->
                signSymptom.description = data
            }
        }
        if(signSymptom.description.isNullOrBlank()){
            message.error("请填写描述")
            return;
        }
        message.loading("正在保存")
        ctx.save(signSymptom,{ resp->
            if(resp.ok()){
                if(signSymptom.id.isNullOrBlank()){ //新增
                    history.push("${urlBase}/signSymptom/edit/${resp.data?.id}")
                }else {
                    resp.data?.let { setSignSymptom(it) }
                }
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    fun getCharacteristics(){
        ctx.getCharacteristics(props.id,{ resp->
            if(resp.ok()){
                setCharacteristics(resp.data!!)
            }else{
                message.error("加载症状特征失败，${resp.message}")
            }
        },{
            message.error("加载症状特征失败，${it.message}")
        })
    }

    fun getExclusiveSignSymptoms(){
        ctx.getSignSymptomRelations(props.id,SignSymptomRelationType.互斥,{ resp->
            if(resp.ok()){
                exclusiveSignSymptoms = resp.data!!
                exclusiveSignSymptomIds = resp.data!!.map{"${if(it.signSymptomId == props.id) it.signSymptomId2 else it.signSymptomId}"}
            }else{
                message.error("加载互斥项失败，${resp.message}")
            }
        },{
            message.error("加载互斥项失败，${it.message}")
        })
    }

    fun saveCharacter(){
        if(editingSignSymptomCharacteristic.signSymptomId.isNullOrBlank()){
            message.error("症状ID不可为空")
            return;
        }
        if(editingSignSymptomCharacteristic.description.isNullOrBlank()){
            message.error("请填写特征");
            return;
        }

        message.loading("正在保存")
        ctx.saveCharacteristic(editingSignSymptomCharacteristic,{ resp->
            if(resp.ok()){
                message.success("保存成功！")
                getCharacteristics()
                setShowCharacteristicEditForm(false)
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    fun saveExclusiveSignSymptom(){
        if(editingExclusiveSignSymptom.signSymptomId.isNullOrBlank()){
            message.error("症状ID不可为空")
            return;
        }
        if(editingExclusiveSignSymptom.signSymptomId2.isNullOrBlank()){
            message.error("请选择互斥项");
            return;
        }

        message.loading("正在保存")
        ctx.saveSignSymptomRelation(editingExclusiveSignSymptom,{ resp->
            if(resp.ok()){
                message.success("保存成功！")
                getExclusiveSignSymptoms()
                showExclusiveSignSymptomcEditForm = false;
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(signSymptom) {
        console.log(signSymptom,editor)
        if(editor != null && signSymptom.description != null && signSymptom.description != editor.getData()){
            editor.setData(signSymptom.description!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(editor){
        if(editor != null && !editorContentLoaded && signSymptom.description != null && signSymptom.description != editor.getData()){
            editor.setData(signSymptom.description!!)
            setEditorContentLoaded(true)
        }
    }

    fun flattenOptions(options:Array<CascadedOption<String>>):Array<CascadedOption<String>>{
        var flatten = arrayOf<CascadedOption<String>>()
        options.forEach{ option ->
            if(option.children != null){
                option.children!!.forEach{
                    flatten += it
                }
            }else{
                flatten += option
            }
        }

        return flatten
    }


    useEffect(props.id) {
        if("new"!=props.id){
            if(32 == props.id?.length?:0) {
                ctx.getDetail(props.id,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setSignSymptom(resp.data!!)
                        //setTitle(resp.data!!.name?.getLiteral()?:"")
                    }else{
                        message.error("获取体征症状失败")
                    }
                },{
                    message.error("获取体征症状失败")
                })
                getCharacteristics()
                getExclusiveSignSymptoms();
            }
        }
        //获取症状列表
        ctx.getNames({ resp->
            if(resp.ok()){
                setSignSymptomNames(resp.data!!)
            }else{
                message.error("获取体征症状失败:${resp.message}")
            }
        },{
            message.error("获取体征症状失败:${it.message}")
        })

        ctx.getOptions({ resp->
            if(resp.ok()){
                signSymptomOptions = flattenOptions(resp.data!!)
            }else{
                message.error("获取体征症状选项失败:${resp.message}")
            }
        },{
            message.error("获取体征症状选项失败:${it.message}")
        })

    }

    useEffectOnce {
        val existingScript = document.getElementById("editor")
        existingScript?.let {
            val script = document.createElement("script") as HTMLScriptElement
            script.src = "/ckeditor.js";
            script.id = "editor";
            document.body?.appendChild(script);

            script.onload = {
                setEditorScriptLoaded(true)

                ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
                    toolbar = jsObject <EditorToolbarConf> {
                        items = arrayOf(
                            "|",
                            "bold",
                            "italic",
                            "underline",
                            "fontSize",
                            "fontColor",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "imageUpload",
                            "blockQuote",
                            "insertTable",
                            "undo",
                            "redo",
                            "horizontalLine"
                        )
                    }
                    language = "zh-cn"
                    licenseKey = ""
                }
                )
                    .then(::onEditorInit)
                    .catch { error ->
                        console.error(error);
                    }

                ///
            }
        }
    }

    div("SignSymptomEdit") {
        attrs {
            jsStyle = kotlinext.js.js {
                margin = "20px auto"
                maxWidth = "1920px"
            }
        }

            form {

                formItem {
                    attrs{
                        label = "名称"
                    }
                    if("new" == props.id){
                        if(signSymptomNames.undefined.isNullOrEmpty()){
                            p{
                                +"没有未定义的体征和症状"
                            }
                        }else{
                            select<String, SelectComponent<String>> {
                                attrs {
                                    showSearch = true
                                    style = kotlinext.js.js { width = 200 }
                                    value = signSymptom.name?.getLiteral()
                                    onChange = { value: String, option: Any ->
                                        val _editing = Object.assign(SignSymptom(), signSymptom)
                                        _editing.name = SignSymptomName.valueOf(value)
                                        setSignSymptom(_editing)
                                    }
                                }
                                signSymptomNames.undefined.forEach { name ->
                                    option {
                                        attrs.value = name.getLiteral()
                                        +name.getLiteral()
                                    }
                                }
                            }
                        }
                    }else{
                        select<String, SelectComponent<String>> {
                            attrs {
                                disabled = true
                                style = kotlinext.js.js { width = 200 }
                                value = signSymptom.name?.getLiteral()
                                onChange = { value: String, option: Any ->
                                   /* val _editing = Object.assign(SignSymptom(), signSymptom)
                                    _editing.name = SignSymptomName.valueOf(value)
                                    setSignSymptom(_editing)*/
                                }
                            }
                            signSymptomNames.defined.forEach { name ->
                                option {
                                    attrs.value = name.getLiteral()
                                    +name.getLiteral()
                                }
                            }
                        }
                    }

                }

                formItem {
                    attrs{
                        label = "别名"
                    }
                    input {
                        attrs {
                            value = signSymptom?.alias?:""
                            placeholder = "请填写别名"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SignSymptom(),signSymptom)
                                entity.alias = event.target.value as String
                                setSignSymptom(entity)
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "分类"
                    }
                    radioGroup {
                        attrs {
                            onChange = {event: RadioChangeEvent->
                                val _editing = Object.assign(SignSymptom(), signSymptom)
                                _editing.category = com.jingfangpai.common.orm.mapping.enums.SignSymptomCategory.valueOf(event.target.value!! as String)
                                setSignSymptom(_editing)
                            }
                            value = signSymptom.category?.getLiteral()
                        }
                        com.jingfangpai.common.orm.mapping.enums.SignSymptomCategory.values().forEach { type->
                            radio {
                                attrs.value = type.getLiteral()
                                +type.getLiteral()
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "类型"
                    }
                    radioGroup {
                        attrs {
                            onChange = {event: RadioChangeEvent->
                                val _editing = Object.assign(SignSymptom(), signSymptom)
                                _editing.type = SignSymptomType.valueOf(event.target.value!! as String)
                                setSignSymptom(_editing)
                            }
                            value = signSymptom.type?.getLiteral()
                        }
                        SignSymptomType.values().forEach { type->
                            radio {
                                attrs.value = type.getLiteral()
                                +type.getLiteral()
                            }
                        }
                    }
                }

                //if(SignSymptomType.集合 == signSymptom.type){
                    formItem {
                        attrs{
                            label = "所属集合"
                        }
                        select<String, SelectComponent<String>> {
                            attrs {
                                disabled = SignSymptomType.集合 != signSymptom.type
                                showSearch = true
                                style = kotlinext.js.js { width = 200 }
                                value = signSymptom.name?.getLiteral()
                                onChange = { value: String, option: Any ->
                                    val _editing = Object.assign(SignSymptom(), signSymptom)
                                    _editing.name = SignSymptomName.valueOf(value)
                                    setSignSymptom(_editing)
                                }
                            }
                            signSymptomNames.defined.forEach { name ->
                                option {
                                    attrs.value = name.getLiteral()
                                    +name.getLiteral()
                                }
                            }
                        }
                    }
                //}

                formItem {
                    attrs{
                        label = "表现特征"
                    }
                    if(characteristics.isEmpty()){
                        button {
                            attrs{
                                type = "link"
                                onClick = {
                                    setEditingSignSymptomCharacteristic(SignSymptomCharacteristic().apply{
                                        signSymptomId = signSymptom.id
                                        createdBy = AuthService.getUserAuthData()?.id
                                        weight = 1
                                        status = SignSymptomCharacteristicStatus.正常
                                        createdOn = DateTime()
                                    })
                                    setShowCharacteristicEditForm(true)
                                }
                            }
                            +"添加症状特征"
                        }
                    }else{
                        list<SignSymptomCharacteristic, ListComponent<SignSymptomCharacteristic>>{
                            attrs{
                                itemLayout = "horizontal"
                                size="small"
                                dataSource = characteristics
                                renderItem = { signSymptomCharacteristic: SignSymptomCharacteristic, characteristicIndex: Number ->
                                    val _index = characteristicIndex.toInt()
                                    listItem {
                                        attrs{
                                            actions = arrayOf(
                                                buildElement {
                                                    button{
                                                        attrs{
                                                            type = "link"
                                                            onClick = {
                                                                setShowCharacteristicEditForm(true)
                                                                setEditingSignSymptomCharacteristic(signSymptomCharacteristic)
                                                            }
                                                        }
                                                        +"编辑"
                                                    }
                                                }
                                            )
                                        }
                                        listItemMeta {
                                            attrs{
                                                title = buildElement{
                                                    div{
                                                        span{
                                                            +"${signSymptomCharacteristic.name?:""}"
                                                        }
                                                        space {
                                                            attrs{
                                                                style = kotlinext.js.js {
                                                                    fontWeight = "normal"
                                                                }
                                                            }

                                                            button{
                                                                attrs{
                                                                    type = "link"
                                                                    size = "small"
                                                                    onClick = {
                                                                        var preWeight = if(_index-1>0) (characteristics[_index-1].weight?:1) else 1
                                                                        setShowCharacteristicEditForm(true)
                                                                        setEditingSignSymptomCharacteristic(SignSymptomCharacteristic().apply {
                                                                            signSymptomId = props.id
                                                                            createdBy = AuthService.getUserAuthData()?.id
                                                                            weight = preWeight
                                                                            status = SignSymptomCharacteristicStatus.正常
                                                                            createdOn = DateTime()
                                                                        })
                                                                    }
                                                                }
                                                                +"上方插入"
                                                            }
                                                            button{
                                                                attrs{
                                                                    type = "link"
                                                                    size = "small"
                                                                    onClick = {
                                                                        var nextWeight = if(_index<(characteristics.size-1)) characteristics[_index+1].weight?:0 else ((signSymptomCharacteristic.weight?:1)+1)
                                                                        setShowCharacteristicEditForm(true)
                                                                        setEditingSignSymptomCharacteristic(SignSymptomCharacteristic().apply {
                                                                            signSymptomId = props.id
                                                                            createdBy = AuthService.getUserAuthData()?.id
                                                                            weight = nextWeight
                                                                            status = SignSymptomCharacteristicStatus.正常
                                                                        })
                                                                    }
                                                                }
                                                                +"下方插入"
                                                            }
                                                        }
                                                    }
                                                }
                                                description = signSymptomCharacteristic.description
                                            }
                                        }
                                    }
                                }

                            }
                        }

                    }

                }

                formItem {
                    attrs{
                        label = "描述"
                    }
                    div{
                        textarea{
                            attrs{
                                rows = "40"
                            }
                            attrs["id"] = "editor"
                        }
                    }
                }

                if(!signSymptom.id.isNullOrBlank()){
                    formItem {
                        attrs {
                            label = "互斥项"
                        }
                        space {
                            exclusiveSignSymptoms.forEach {
                                tag {
                                    +"${if(it.signSymptomId == props.id) it.signSymptomName2 else it.signSymptomName}"
                                }
                            }
                        }
                        button {
                            attrs{
                                type = "link"
                                onClick = {
                                    editingExclusiveSignSymptom = SignSymptomRelation().apply{
                                        signSymptomId = signSymptom.id
                                        type = SignSymptomRelationType.互斥
                                        createdBy = AuthService.getUserAuthData()?.id
                                        createdOn = DateTime()
                                    }
                                    showExclusiveSignSymptomcEditForm = true
                                }
                            }
                            +"添加"
                        }
                    }
                }

                formItem {
                    button {
                        attrs{
                            onClick = ::onSave
                        }
                        +"保存"
                    }
                }

            }
        modal {
            attrs{
                title = if(editingSignSymptomCharacteristic.id.isNullOrBlank()) "添加症状特征" else "编辑症状特征"
                visible = showCharacteristicEditForm
                onCancel = {
                    setShowCharacteristicEditForm(false)
                }
                onOk = {
                    saveCharacter()
                }
            }
            form{
                attrs{
                    layout = "horizontal"
                }
                formItem{
                    attrs{
                        label = "特征标签"
                        help = "如“汗多”、“得温痛减”、“遇寒加剧”、“欲汗不得汗”"
                    }

                    input {
                        attrs {
                            value = editingSignSymptomCharacteristic.name?:""
                            placeholder = "请填写症状特征"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SignSymptomCharacteristic(),editingSignSymptomCharacteristic)
                                entity.name = event.target.value as String
                                setEditingSignSymptomCharacteristic(entity)
                            }
                        }
                    }

                }
            }
            formItem {
                attrs{
                    label = "特征描述"
                }
                textArea {
                    attrs {
                        value = editingSignSymptomCharacteristic.description ?:""
                        rows = 3
                        onChange = {event: dynamic ->
                            val symptom = Object.assign(SignSymptomCharacteristic(),editingSignSymptomCharacteristic)
                            symptom.description = event.target.value as String
                            setEditingSignSymptomCharacteristic(symptom)
                        }
                    }
                }
            }
            formItem {
                attrs {
                    label = "特征排序"
                }

                select<String, SelectComponent<String>> {
                    attrs {
                        mode = "default"
                        labelInValue = false
                        value = "${editingSignSymptomCharacteristic.weight ?: ""}"
                        placeholder = "排序位置"
                        optionLabelProp = "label"
                        filterOption = ::filterOptionFun
                        //onSearch = fetchUser
                        onChange = { selected: String, any: Any ->
                            val entity = Object.assign(SignSymptomCharacteristic(), editingSignSymptomCharacteristic)
                            entity.weight = selected.toInt()
                            setEditingSignSymptomCharacteristic(entity)
                        }
                        style = kotlinext.js.js { width = "100%" }
                    }
                    IntRange(1, 30).forEach { opt ->
                        option {
                            attrs {
                                label = "${opt}"
                                value = "${opt}"
                            }
                            +"${opt}"
                        }
                    }
                }
            }
        }

        modal{
            attrs{
                title = if(editingExclusiveSignSymptom.signSymptomId.isNullOrBlank()) "添加互斥" else "编辑互斥"
                visible = showExclusiveSignSymptomcEditForm
                onCancel = {
                    showExclusiveSignSymptomcEditForm = false
                }
                onOk = {
                    saveExclusiveSignSymptom()
                }
            }
            form{
                attrs{
                    layout = "horizontal"
                }
                select<String, SelectComponent<String>> {
                    attrs {
                        showSearch = true
                        style = kotlinext.js.js { width = 200 }
                        value = editingExclusiveSignSymptom.signSymptomId2
                        showSearch = true
                        filterOption = ::filterOptionFun
                        onChange = { value: String, option: Any ->
                            val _editing = Object.assign(SignSymptomRelation(), editingExclusiveSignSymptom)
                            _editing.signSymptomId2 = value
                            editingExclusiveSignSymptom = _editing
                        }
                    }
                    signSymptomOptions.filter { it.value != props.id && !exclusiveSignSymptomIds.contains(it.value)}.forEach { signSymptom ->
                        option {
                            attrs.value = signSymptom.value
                            +signSymptom.label
                        }
                    }
                }
            }
        }

    }
}
